/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Shared_SaveInputs */

const en_admin_shared_save = /** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const de_admin_shared_save = /** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const es_admin_shared_save = /** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const fr_admin_shared_save = /** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const nl_admin_shared_save = /** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan`)
};

/** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */
const it_admin_shared_save = en_admin_shared_save;

/** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */
const pt_br2_admin_shared_save = en_admin_shared_save;

/** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */
const pl_admin_shared_save = en_admin_shared_save;

/** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */
const hu_admin_shared_save = en_admin_shared_save;

/** @type {(inputs: Admin_Shared_SaveInputs) => LocalizedString} */
const ro_admin_shared_save = en_admin_shared_save;

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Admin_Shared_SaveInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_save = /** @type {((inputs?: Admin_Shared_SaveInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_SaveInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_save(inputs)
	if (locale === "de") return de_admin_shared_save(inputs)
	if (locale === "es") return es_admin_shared_save(inputs)
	if (locale === "fr") return fr_admin_shared_save(inputs)
	if (locale === "nl") return nl_admin_shared_save(inputs)
	if (locale === "it") return it_admin_shared_save(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_save(inputs)
	if (locale === "pl") return pl_admin_shared_save(inputs)
	if (locale === "hu") return hu_admin_shared_save(inputs)
	return ro_admin_shared_save(inputs)
});
export { admin_shared_save as "admin.shared.save" }